import {
  createFileRoute,
  redirect,
} from '@tanstack/react-router';

export const Route = createFileRoute('/_app/_authenticated/mydigitalworkers/gary/_garyLayout/settings/')({
  // component: RouteComponent,
  loader: async () => {
    redirect({
      to: '/mydigitalworkers/gary/settings/users',
      throw: true,
    });
  },
});
